import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/book',
      name: 'book',
      component: () => import(/* webpackChunkName: "about" */ './views/Book.vue')
    },
    {
      path: '/order/:orderNumber?',
      name: 'order-tracking',
      component: () => import(/* webpackChunkName: "order-tracking" */ './views/OrderTracking.vue')
    },
    {
      path: '/order',
      name: 'order-search',
      component: () => import(/* webpackChunkName: "order-tracking" */ './views/OrderTracking.vue')
    },
    {
      path: '/payment-thank-you',
      name: 'payment-thank-you',
      component: () => import(/* webpackChunkName: "payment-thank-you" */ './views/PaymentThankYou.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
